'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { generateRoomId } from '@/lib/client-utils';
import { companyConfig } from '@/lib/config';

export default function Page() {
  const router = useRouter();

  useEffect(() => {
    // Automatically redirect to a new room (Demo mode without encryption)
    router.replace(`/rooms/${generateRoomId()}`);
  }, [router]);

  return (
    <main data-lk-theme="default" style={{ height: '100vh', display: 'grid', placeItems: 'center' }}>
      <div style={{ textAlign: 'center' }}>
        <div className="logo-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.75rem', marginBottom: '1rem' }}>
          <img src={companyConfig.logoUrl} alt={companyConfig.name} width="56" height="56" />
          <span className="logo-text" style={{ display: 'flex', alignItems: 'baseline', fontSize: '1.5rem', fontWeight: 700, color: '#fff' }}>
            {companyConfig.name}
          </span>
        </div>
        <p style={{ color: 'rgba(255,255,255,0.7)' }}>Loading...</p>
      </div>
    </main>
  );
}
